module.exports = __webpack_public_path__ + "img/发送账单.bdee97f0.svg";